import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'profile.editbutton.edit': {
    id: 'profile.editbutton.edit',
    defaultMessage: 'Edit',
    description: 'A button label',
  },
});

export default messages;
